/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { AddUserOrGroupModule } from '../add-user-or-group/add-user-or-group.module';
import { SelectUserOrGroupComponent } from './select-user-or-group.component';

@NgModule({
    declarations: [SelectUserOrGroupComponent],
    exports: [SelectUserOrGroupComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        AddUserOrGroupModule,
    ],
})
export class SelectUserOrGroupModule { }
